export default __webpack_public_path__ + "static/media/banner-mobile-bg-white-template.ce00eb60.svg";